import { BuyGiftCardsContainer } from "components/UI/atoms";
import {
  Breadcrumb,
  DropdownSortSearch,
  IndexSearch,
  Pagination
} from "components/UI/molecules";
import {
  BrandsGrid,
  BrandsAreaHeader,
  SidebarFilters
} from "components/UI/organisms";
import { INTERNAL_PATHS } from "routes/paths";
import { useGetBrands } from "./utils/useGetBrands";
import { useGetFilters } from "./utils/useGetFilters";
import { BRANDS_PER_PAGE } from "./utils/constants";
import "./index.scss";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

const BREADCRUMB_PATHS = [
  {
    label: "Buy Gift Cards",
    linkTo: INTERNAL_PATHS.BUY_GIFT_CARDS
  }
];

export const BuyGiftCards = () => {
  const {
    brands,
    totalResults,
    currentPage,
    setCurrentPage,
    updateFilters,
    setCurrentSort
  } = useGetBrands();
  const { filters } = useGetFilters();

  const resultsLabel = `${totalResults} Results`;

  return (
    <div className="buy-gift-cards">
      <ReactHelmetWithProvider>
        <meta
          name="description"
          content="Shop for discount gift cards or electronic gift cards at GCX and browse our marketplace for gift cards by brand, price, discount and category"
        />
        <title>
          Buy Gift Cards: Discount Gift Cards from 4,000+ Stores | GCX
        </title>
        <link
          rel="canonical"
          href={process.env.REACT_APP_URL + INTERNAL_PATHS.BUY_GIFT_CARDS}
        />
      </ReactHelmetWithProvider>
      <Breadcrumb list={BREADCRUMB_PATHS} />
      <BuyGiftCardsContainer>
        <div className="buy-container">
          <aside className="sidebar-gift-cards">
            <SidebarFilters filters={filters} onFilterClick={updateFilters} />
          </aside>
          <div className="gift-cards-area">
            <div className="gift-cards-header">
              <BrandsAreaHeader />
              <div className="results-number-and-sort">
                <span className="results">{resultsLabel}</span>
                <DropdownSortSearch
                  onChangeSort={(selectedSort) => setCurrentSort(selectedSort)}
                />
              </div>
            </div>
            <IndexSearch onClickIndex={updateFilters} />
            {brands && <BrandsGrid brands={brands} />}
            <Pagination
              currentPage={currentPage}
              pageSize={BRANDS_PER_PAGE}
              totalCount={totalResults}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </BuyGiftCardsContainer>
    </div>
  );
};
